/* Ava & Theo — theme behaviour. No dependencies, no build step. */
(function () {
  'use strict';

  var strings = window.themeStrings || {};
  var routes = window.routes || {};
  var config = window.themeSettings || {};

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function money(cents) {
    var format = window.themeMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace('{{amount}}', whole + '.' + parts[1])
      .replace('{{amount_no_decimals}}', whole)
      .replace('{{amount_with_comma_separator}}', whole.replace(/,/g, '.') + ',' + parts[1])
      .replace('{{amount_no_decimals_with_comma_separator}}', whole.replace(/,/g, '.'));
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------ storage helpers */
  /* Private browsing can throw on write, so every access is guarded. */

  function storageAvailable() {
    try {
      localStorage.setItem('__t', '1');
      localStorage.removeItem('__t');
      return true;
    } catch (err) {
      return false;
    }
  }

  var HAS_STORAGE = storageAvailable();

  function readList(key) {
    if (!HAS_STORAGE) return [];
    try {
      var raw = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(raw) ? raw.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (err) {
      return [];
    }
  }

  function writeList(key, list) {
    if (!HAS_STORAGE) return;
    try {
      localStorage.setItem(key, JSON.stringify(list));
    } catch (err) { /* quota or private mode — fail quietly */ }
  }

  /* ---------------------------------------------------------- focus trap */

  var openLayers = [];

  function trapFocus(container, trigger) {
    openLayers.push({ container: container, trigger: trigger || document.activeElement });
    document.documentElement.classList.add('is-locked');
    var first = container.querySelector(FOCUSABLE);
    if (first) window.setTimeout(function () { first.focus(); }, 40);
  }

  function releaseFocus(container) {
    var index = -1;
    for (var i = openLayers.length - 1; i >= 0; i--) {
      if (openLayers[i].container === container) { index = i; break; }
    }
    if (index === -1) return;
    var layer = openLayers.splice(index, 1)[0];
    if (!openLayers.length) document.documentElement.classList.remove('is-locked');
    if (layer.trigger && document.contains(layer.trigger)) layer.trigger.focus();
  }

  function topLayer() {
    return openLayers.length ? openLayers[openLayers.length - 1] : null;
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var layer = topLayer();
    if (!layer) return;

    var items = Array.prototype.filter.call(
      layer.container.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetParent !== null || el === document.activeElement; }
    );
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* --------------------------------------------------------------- toast */

  var toastTimer;

  function toast(message) {
    var el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    el.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      el.classList.remove('is-visible');
      window.setTimeout(function () { el.hidden = true; }, 300);
    }, 2600);
  }

  /* ---------------------------------------------------------------- menu */

  document.addEventListener('click', function (event) {
    var burger = event.target.closest('[data-menu-toggle]');
    if (!burger) return;
    var menu = document.getElementById('MobileMenu');
    if (!menu) return;
    var open = menu.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ----------------------------------------------------------- mega menu */

  (function initMegaMenus() {
    var items = document.querySelectorAll('[data-mega-item]');
    if (!items.length) return;

    var closeTimer;

    function panelFor(trigger) {
      var title = trigger.getAttribute('data-mega-trigger');
      var all = document.querySelectorAll('[data-mega-panel]');
      for (var i = 0; i < all.length; i++) {
        if (all[i].getAttribute('data-mega-panel') === title) return all[i];
      }
      return null;
    }

    function closeAll() {
      document.querySelectorAll('[data-mega-panel]').forEach(function (p) { p.hidden = true; });
      document.querySelectorAll('[data-mega-trigger]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
    }

    function open(trigger) {
      window.clearTimeout(closeTimer);
      var panel = panelFor(trigger);
      if (!panel) return;
      closeAll();
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-mega-trigger]');
      if (!trigger) return;

      item.addEventListener('mouseenter', function () { open(trigger); });
      item.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(closeAll, 140);
      });
      trigger.addEventListener('focus', function () { open(trigger); });

      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        open(trigger);
        var panel = panelFor(trigger);
        var link = panel && panel.querySelector(FOCUSABLE);
        if (link) link.focus();
      });
    });

    document.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { window.clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(closeAll, 140);
      });
    });

    document.addEventListener('focusin', function (event) {
      if (!event.target.closest('[data-mega-item]') && !event.target.closest('[data-mega-panel]')) closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !topLayer()) closeAll();
    });
  })();

  /* ----------------------------------------------------------- accordion */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.accordion__btn');
    if (!btn) return;
    var panel = btn.parentElement.nextElementSibling || btn.nextElementSibling;
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.classList.toggle('is-open', !open);
  });

  /* ------------------------------------------------------------- gallery */

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery && gallery.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = thumb.dataset.full;
    main.srcset = '';
    main.alt = thumb.dataset.alt || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (el) {
      el.setAttribute('aria-current', el === thumb ? 'true' : 'false');
    });
  });

  /* ------------------------------------------------------------ quantity */

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(step.dataset.qtyStep, 10);
    input.value = next < 1 ? 1 : next;
  });

  /* ------------------------------------------------------------ variants */

  function initVariantPicker(root) {
    var data = root.querySelector('[data-variants-json]');
    if (!data) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (err) {
      return;
    }

    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var submit = root.querySelector('[data-add-button]');
    var mainImage = document.querySelector('[data-gallery-main]');
    var barPrice = document.querySelector('[data-buybar-price]');
    var barVariant = document.querySelector('[data-buybar-variant]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-group]'), function (group) {
        var active = group.querySelector('[aria-pressed="true"]');
        return active ? active.dataset.value : null;
      });
    }

    function match(values) {
      return variants.filter(function (variant) {
        return values.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      })[0];
    }

    function render() {
      var variant = match(selected());

      if (!variant) {
        submit.disabled = true;
        submit.textContent = strings.unavailable || 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? strings.addToCart : strings.soldOut;

      if (priceEl) {
        var html = '<span class="price__now' + (variant.compare_at_price > variant.price ? ' price__now--sale' : '') + '">' + money(variant.price) + '</span>';
        if (variant.compare_at_price > variant.price) {
          html += '<span class="price__was">' + money(variant.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
      }

      if (barPrice) barPrice.textContent = money(variant.price);
      if (barVariant) barVariant.textContent = variant.title || '';

      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image;
        mainImage.srcset = '';
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('click', function (event) {
      var swatch = event.target.closest('.swatch');
      if (!swatch) return;
      var group = swatch.closest('[data-option-group]');
      group.querySelectorAll('.swatch').forEach(function (el) {
        el.setAttribute('aria-pressed', el === swatch ? 'true' : 'false');
      });
      var label = group.querySelector('[data-option-selected]');
      if (label) label.textContent = swatch.dataset.value;
      render();
    });

    render();
  }

  document.querySelectorAll('[data-product-form]').forEach(initVariantPicker);

  /* ----------------------------------------------------------- countdown */
  /* Kept so nothing breaks for anyone still using it. No section calls it —
     invented urgency is against the brand rules in CLAUDE.md. */

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var minutes = parseInt(el.dataset.countdown, 10) || 60;
    var key = 'avatheo-countdown';
    var end = parseInt(sessionStorage.getItem(key), 10);

    if (!end || isNaN(end) || end < Date.now()) {
      end = Date.now() + minutes * 60000;
      sessionStorage.setItem(key, String(end));
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var left = Math.max(0, end - Date.now());
      var total = Math.floor(left / 1000);
      el.innerHTML =
        '<strong>' + pad(Math.floor(total / 3600)) + '</strong>:' +
        '<strong>' + pad(Math.floor(total % 3600 / 60)) + '</strong>:' +
        '<strong>' + pad(total % 60) + '</strong>';
    }

    tick();
    setInterval(tick, 1000);
  });

  /* ---------------------------------------------------------------- cart */

  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    trapFocus(drawer.querySelector('.cart-drawer__panel') || drawer);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    releaseFocus(drawer.querySelector('.cart-drawer__panel') || drawer);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-close]')) closeDrawer();
    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      refreshCart().then(openDrawer);
    }
  });

  function shippingBar(cart) {
    var threshold = parseInt(config.freeShippingThreshold, 10) || 0;
    if (threshold <= 0) return '';

    var total = cart.total_price;
    var left = threshold - total;
    var pct = Math.min(100, Math.round((total / threshold) * 100));

    var text = left > 0
      ? (strings.freeShippingAway || 'You are [[amount]] away from free shipping.').replace('[[amount]]', money(left))
      : (strings.freeShippingReached || 'You have unlocked free shipping.');

    return '' +
      '<div class="ship-bar">' +
        '<p class="ship-bar__text" aria-live="polite">' + escapeHtml(text) + '</p>' +
        '<div class="ship-bar__track"><span class="ship-bar__fill" style="width:' + pct + '%"></span></div>' +
      '</div>';
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="empty-state">' + escapeHtml(strings.cartEmpty || 'Your cart is empty') + '</p>';
      return;
    }

    var html = shippingBar(cart);

    html += cart.items.map(function (item) {
      var image = item.image ? item.image.replace(/(\.[^.]*)$/, '_160x$1') : '';
      return '' +
        '<div class="cart-line">' +
          (image ? '<img src="' + image + '" alt="" width="64" height="64" loading="lazy">' : '<span class="cart-line__ph"></span>') +
          '<div>' +
            '<a class="cart-line__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
            (item.variant_title ? '<div class="cart-line__meta">' + escapeHtml(item.variant_title) + '</div>' : '') +
            '<div class="cart-line__meta">' + item.quantity + ' &times; ' + money(item.final_price) + '</div>' +
            '<button type="button" class="cart-line__remove" data-cart-remove="' + item.key + '">' + escapeHtml(strings.remove || 'Remove') + '</button>' +
          '</div>' +
        '</div>';
    }).join('');

    html += '' +
      '<div class="cart-foot">' +
        '<div class="cart-foot__row"><span>' + escapeHtml(strings.subtotal || 'Subtotal') + '</span><strong>' + money(cart.total_price) + '</strong></div>' +
        '<a class="btn btn--full btn--lg" href="/checkout">' + escapeHtml(strings.checkout || 'Checkout') + '</a>' +
        '<a class="btn btn--outline btn--full mt-1" href="' + (routes.cart || '/cart') + '">' + escapeHtml(strings.viewCart || 'View cart') + '</a>' +
      '</div>';

    body.innerHTML = html;
  }

  function refreshCart() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    fetch(routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 })
    })
      .then(function (res) { return res.json(); })
      .then(renderCart);
  });

  function addToCart(items) {
    return fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-product-form] form, .card__form');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[data-add-button]');
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = '…'; }

    fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = original; }
      });
  });

  if (document.querySelector('[data-cart-count]')) refreshCart();

  /* ------------------------------------------------------ generic modals */

  function modalEl(name) {
    return document.querySelector('[data-modal="' + name + '"]');
  }

  function openModal(name, trigger) {
    var el = modalEl(name);
    if (!el) return null;
    el.setAttribute('aria-hidden', 'false');
    el.classList.add('is-open');
    trapFocus(el.querySelector('.modal__box') || el, trigger);
    return el;
  }

  function closeModal(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    el.classList.remove('is-open');
    releaseFocus(el.querySelector('.modal__box') || el);
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-modal-open]');
    if (open) {
      event.preventDefault();
      openModal(open.getAttribute('data-modal-open'), open);
      return;
    }
    var close = event.target.closest('[data-modal-close]');
    if (close) closeModal(close.closest('[data-modal]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var layer = topLayer();
    if (!layer) return;

    var modal = layer.container.closest('[data-modal]');
    if (modal) { closeModal(modal); return; }
    if (layer.container.closest('#CartDrawer')) { closeDrawer(); return; }
    if (layer.container.closest('[data-wishlist-drawer]')) { closeWishlist(); return; }
    if (layer.container.closest('[data-search-overlay]')) { closeSearch(); return; }
    if (layer.container.classList.contains('facets')) { closeFacets(); }
  });

  /* ---------------------------------------------------------- quick add */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-add]');
    if (!trigger) return;

    event.preventDefault();
    var handle = trigger.getAttribute('data-quick-add');
    var modal = openModal('QuickAdd', trigger);
    if (!modal) { window.location.href = trigger.href; return; }

    var body = modal.querySelector('[data-quick-add-body]');
    body.innerHTML = '<p class="empty-state">…</p>';

    fetch((routes.root || '/') + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('not found');
        return res.json();
      })
      .then(function (product) { renderQuickAdd(body, product); })
      .catch(function () { window.location.href = trigger.href; });
  });

  function renderQuickAdd(body, product) {
    var firstAvailable = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var state = product.options.map(function (_, i) {
      return firstAvailable ? firstAvailable.options[i] : null;
    });

    function currentVariant() {
      return product.variants.filter(function (v) {
        return state.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    }

    function optionAvailable(index, value) {
      var probe = state.slice();
      probe[index] = value;
      return product.variants.some(function (v) {
        return v.available && probe.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function draw() {
      var variant = currentVariant();
      var image = product.featured_image
        ? product.featured_image.replace(/(\.[^.?]*)(\?|$)/, '_400x$1$2')
        : '';

      var html = '<div class="quick-add">' +
        (image ? '<img class="quick-add__img" src="' + image + '" alt="" width="150" height="150" loading="lazy">' : '') +
        '<div class="quick-add__info">' +
        '<p class="quick-add__title">' + escapeHtml(product.title) + '</p>' +
        '<p class="price"><span class="price__now">' + money(variant ? variant.price : product.price) + '</span></p>';

      product.options.forEach(function (option, index) {
        var name = option.name || option;
        var values = option.values || [];
        html += '<div class="quick-add__group">' +
          '<span class="variant__label">' + escapeHtml(name) + ': <span>' + escapeHtml(state[index] || '') + '</span></span>' +
          '<div class="swatches">';
        values.forEach(function (value) {
          var ok = optionAvailable(index, value);
          html += '<button type="button" class="swatch' + (ok ? '' : ' is-unavailable') + '"' +
            ' data-qa-option="' + index + '" data-qa-value="' + escapeHtml(value) + '"' +
            ' aria-pressed="' + (state[index] === value ? 'true' : 'false') + '"' +
            (ok ? '' : ' disabled') + '>' + escapeHtml(value) + '</button>';
        });
        html += '</div></div>';
      });

      var label = variant
        ? (variant.available ? (strings.addToBag || 'Add to bag') : (strings.soldOut || 'Sold out'))
        : (strings.unavailable || 'Unavailable');

      html += '<button type="button" class="btn btn--full" data-qa-add' +
        (variant && variant.available ? '' : ' disabled') + '>' + escapeHtml(label) + '</button>' +
        '</div></div>';

      body.innerHTML = html;
    }

    if (!body.hasAttribute('data-bound')) {
      body.setAttribute('data-bound', 'true');
      body.addEventListener('click', function (event) {
        var opt = event.target.closest('[data-qa-option]');
        if (opt) {
          state[parseInt(opt.getAttribute('data-qa-option'), 10)] = opt.getAttribute('data-qa-value');
          draw();
          return;
        }

        var add = event.target.closest('[data-qa-add]');
        if (!add) return;

        var variant = currentVariant();
        if (!variant) return;

        add.disabled = true;
        add.textContent = '…';

        addToCart([{ id: variant.id, quantity: 1 }])
          .then(function () {
            closeModal(modalEl('QuickAdd'));
            return refreshCart();
          })
          .then(function () { openDrawer(); })
          .catch(function () {
            add.disabled = false;
            add.textContent = strings.addToBag || 'Add to bag';
          });
      });
    }

    body.__state = state;
    body.__current = currentVariant;
    draw();
  }

  /* ------------------------------------------------ complete the look */

  (function initBundle() {
    var grid = document.querySelector('[data-look-grid]');
    var box = document.querySelector('[data-look-bundle]');
    if (!grid || !box) return;

    var handles = Array.prototype.map.call(
      grid.querySelectorAll('[data-product-handle]'),
      function (el) { return el.getAttribute('data-product-handle'); }
    );
    if (!handles.length) return;

    box.hidden = false;

    var button = box.querySelector('[data-look-add-all]');
    if (!button) return;

    button.addEventListener('click', function () {
      var original = button.textContent;
      button.disabled = true;
      button.textContent = '…';

      Promise.all(handles.map(function (handle) {
        return fetch((routes.root || '/') + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      }))
        .then(function (products) {
          var items = products
            .filter(function (p) { return p && p.variants; })
            .map(function (p) {
              var v = p.variants.filter(function (x) { return x.available; })[0];
              return v ? { id: v.id, quantity: 1 } : null;
            })
            .filter(Boolean);

          if (!items.length) throw new Error('nothing available');
          return addToCart(items);
        })
        .then(function () { return refreshCart(); })
        .then(function () { openDrawer(); })
        .catch(function () { toast(strings.unavailable || 'Unavailable'); })
        .finally(function () {
          button.disabled = false;
          button.textContent = original;
        });
    });
  })();

  /* ----------------------------------------------------- sticky buy bar */

  (function initBuyBar() {
    var bar = document.querySelector('[data-buybar]');
    var sentinel = document.querySelector('[data-buy-sentinel]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }, { threshold: 0 });

    observer.observe(sentinel);

    var add = bar.querySelector('[data-buybar-add]');
    if (!add) return;

    add.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form] form');
      if (!form) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
    });
  })();

  /* ----------------------------------------------------------- wishlist */

  var WISH_KEY = 'avatheo-wishlist';
  var wishDrawer = document.querySelector('[data-wishlist-drawer]');

  function wishList() { return readList(WISH_KEY); }

  function paintWishButtons() {
    var saved = wishList();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = saved.indexOf(btn.getAttribute('data-wishlist-toggle')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-label', on
        ? (strings.wishlistRemove || 'Remove from wishlist')
        : (strings.wishlistSave || 'Save to wishlist'));
    });

    var badge = document.querySelector('[data-wishlist-badge]');
    if (badge) {
      badge.textContent = saved.length;
      badge.hidden = saved.length === 0;
    }
    var count = document.querySelector('[data-wishlist-count]');
    if (count) {
      count.textContent = '(' + saved.length + ')';
      count.hidden = saved.length === 0;
    }
  }

  if (HAS_STORAGE) {
    var wishOpen = document.querySelector('[data-wishlist-open]');
    if (wishOpen) wishOpen.hidden = false;
  } else {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) { b.hidden = true; });
  }

  function fillWishlist() {
    if (!wishDrawer) return;
    var list = wishList();
    var empty = wishDrawer.querySelector('[data-wishlist-empty]');
    var target = wishDrawer.querySelector('[data-wishlist-list]');
    if (!target) return;

    if (!list.length) {
      if (empty) empty.hidden = false;
      target.innerHTML = '';
      return;
    }
    if (empty) empty.hidden = true;

    Promise.all(list.map(function (handle) {
      return fetch((routes.root || '/') + 'products/' + handle + '?section_id=card-product')
        .then(function (res) { return res.ok ? res.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      target.innerHTML = chunks
        .filter(Boolean)
        .map(function (html) { return '<li>' + html + '</li>'; })
        .join('');
      paintWishButtons();
    });
  }

  function openWishlist(trigger) {
    if (!wishDrawer) return;
    wishDrawer.setAttribute('aria-hidden', 'false');
    wishDrawer.classList.add('is-open');
    fillWishlist();
    trapFocus(wishDrawer.querySelector('.drawer__panel') || wishDrawer, trigger);
  }

  function closeWishlist() {
    if (!wishDrawer) return;
    wishDrawer.setAttribute('aria-hidden', 'true');
    wishDrawer.classList.remove('is-open');
    releaseFocus(wishDrawer.querySelector('.drawer__panel') || wishDrawer);
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-wishlist-open]');
    if (openBtn) { event.preventDefault(); openWishlist(openBtn); return; }
    if (event.target.closest('[data-wishlist-close]')) { closeWishlist(); return; }

    var btn = event.target.closest('[data-wishlist-toggle]');
    if (!btn || !HAS_STORAGE) return;

    var handle = btn.getAttribute('data-wishlist-toggle');
    var list = wishList();
    var index = list.indexOf(handle);

    if (index === -1) {
      list.unshift(handle);
      toast(strings.wishlistSaved || 'Saved');
    } else {
      list.splice(index, 1);
      toast(strings.wishlistRemove || 'Removed');
    }

    writeList(WISH_KEY, list);
    paintWishButtons();
    if (wishDrawer && wishDrawer.getAttribute('aria-hidden') === 'false') fillWishlist();
  });

  paintWishButtons();

  /* ----------------------------------------------------- recently viewed */

  var RECENT_KEY = 'avatheo-recent';

  (function trackRecent() {
    var host = document.querySelector('[data-recently-viewed-track]');
    if (!host || !HAS_STORAGE) return;
    var handle = host.getAttribute('data-recently-viewed-track');
    if (!handle) return;

    var list = readList(RECENT_KEY).filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeList(RECENT_KEY, list.slice(0, 8));
  })();

  (function renderRecent() {
    var box = document.querySelector('[data-recently-viewed]');
    if (!box || !HAS_STORAGE) return;

    var current = box.getAttribute('data-current');
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 5;
    var list = readList(RECENT_KEY).filter(function (h) { return h && h !== current; }).slice(0, limit);

    if (list.length < 2) return;

    var grid = box.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    Promise.all(list.map(function (handle) {
      return fetch((routes.root || '/') + 'products/' + handle + '?section_id=card-product')
        .then(function (res) { return res.ok ? res.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      var html = chunks.filter(Boolean).map(function (c) { return '<li>' + c + '</li>'; }).join('');
      if (!html) return;
      grid.innerHTML = html;
      box.hidden = false;
      paintWishButtons();
    });
  })();

  /* -------------------------------------------------------------- search */

  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchTimer;

  function openSearch(trigger) {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchOverlay.classList.add('is-open');
    trapFocus(searchOverlay.querySelector('.overlay__panel') || searchOverlay, trigger);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchOverlay.classList.remove('is-open');
    releaseFocus(searchOverlay.querySelector('.overlay__panel') || searchOverlay);
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-search-open]');
    if (openBtn) { event.preventDefault(); openSearch(openBtn); return; }
    if (event.target.closest('[data-search-close]')) { closeSearch(); return; }

    var term = event.target.closest('[data-search-term]');
    if (term && searchOverlay) {
      var field = searchOverlay.querySelector('[data-search-input]');
      field.value = term.getAttribute('data-search-term');
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.focus();
    }
  });

  if (searchOverlay) {
    (function initSearch() {
      var field = searchOverlay.querySelector('[data-search-input]');
      var results = searchOverlay.querySelector('[data-search-results]');
      var defaults = searchOverlay.querySelector('[data-search-default]');
      var clear = searchOverlay.querySelector('[data-search-clear]');
      if (!field || !results) return;

      function highlight(text, q) {
        var safe = escapeHtml(text);
        var index = safe.toLowerCase().indexOf(q.toLowerCase());
        if (index === -1) return safe;
        return safe.slice(0, index) + '<mark>' + safe.slice(index, index + q.length) + '</mark>' + safe.slice(index + q.length);
      }

      function draw(q, data) {
        var res = (data.resources && data.resources.results) || {};
        var products = res.products || [];
        var cols = res.collections || [];

        if (!products.length && !cols.length) {
          results.innerHTML = '<div class="empty-state">' +
            '<p class="empty-state__title">' +
            escapeHtml((strings.searchNoResults || 'No results for [[terms]]').replace('[[terms]]', q)) +
            '</p><p>' + escapeHtml(strings.searchNoResultsHint || '') + '</p></div>';
          return;
        }

        var html = '';

        if (cols.length) {
          html += '<div class="search-block"><div class="chips">';
          cols.forEach(function (c) {
            html += '<a class="chip" href="' + c.url + '">' + highlight(c.title, q) + '</a>';
          });
          html += '</div></div>';
        }

        if (products.length) {
          html += '<div class="search-block"><ul class="search-list" role="list">';
          products.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url
              ? '<img src="' + p.featured_image.url + '" alt="" width="56" height="56" loading="lazy">'
              : '<span class="search-list__ph"></span>';
            html += '<li><a class="search-list__item" href="' + p.url + '">' + img +
              '<span class="search-list__text">' +
              '<span class="search-list__title">' + highlight(p.title, q) + '</span>' +
              (p.vendor ? '<span class="search-list__meta">' + escapeHtml(p.vendor) + '</span>' : '') +
              '</span>' +
              '<span class="search-list__price">' + (p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</span>' +
              '</a></li>';
          });
          html += '</ul><a class="btn btn--outline" href="' + (routes.search || '/search') +
            '?q=' + encodeURIComponent(q) + '">' +
            escapeHtml(strings.searchViewAll || 'View all results') + '</a></div>';
        }

        results.innerHTML = html;
      }

      field.addEventListener('input', function () {
        var q = field.value.trim();
        if (clear) clear.hidden = q.length === 0;

        window.clearTimeout(searchTimer);

        if (q.length < 2) {
          results.innerHTML = '';
          if (defaults) defaults.hidden = false;
          return;
        }

        if (defaults) defaults.hidden = true;

        searchTimer = window.setTimeout(function () {
          var url = (routes.predictive || '/search/suggest') +
            '.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection&resources[limit]=6';

          fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (data) { draw(q, data); })
            .catch(function () {});
        }, 220);
      });

      if (clear) {
        clear.addEventListener('click', function () {
          field.value = '';
          clear.hidden = true;
          results.innerHTML = '';
          if (defaults) defaults.hidden = false;
          field.focus();
        });
      }
    })();
  }

  /* -------------------------------------------------------------- facets */

  var facets = document.querySelector('.facets');

  function openFacets(trigger) {
    if (!facets) return;
    facets.classList.add('is-open');
    var btn = document.querySelector('[data-facet-drawer-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    trapFocus(facets, trigger);
  }

  function closeFacets() {
    if (!facets) return;
    facets.classList.remove('is-open');
    var btn = document.querySelector('[data-facet-drawer-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    releaseFocus(facets);
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-facet-drawer-open]');
    if (openBtn) { openFacets(openBtn); return; }
    if (event.target.closest('[data-facet-drawer-close]')) closeFacets();
  });

  (function initFacetFetching() {
    var root = document.querySelector('[data-collection-root]');
    if (!root) return;

    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    var busy = false;

    function swap(doc, selector) {
      var next = doc.querySelector(selector);
      var current = document.querySelector(selector);
      if (next && current) current.innerHTML = next.innerHTML;
    }

    function swapOrClear(doc, selector) {
      var next = doc.querySelector(selector);
      var current = document.querySelector(selector);
      if (next && current) {
        current.innerHTML = next.innerHTML;
      } else if (current) {
        current.innerHTML = '';
      }
    }

    function swapFacets(doc) {
      var next = doc.querySelector('.facets__form');
      var current = document.querySelector('.facets__form');
      if (!next || !current) return;

      var openStates = Array.prototype.map.call(current.querySelectorAll('.facet'), function (d) { return d.open; });
      current.innerHTML = next.innerHTML;
      current.querySelectorAll('.facet').forEach(function (d, i) {
        if (typeof openStates[i] === 'boolean') d.open = openStates[i];
      });
    }

    function apply(url, push) {
      if (busy) return;
      busy = true;
      root.classList.add('is-loading');

      var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;

      fetch(fetchUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('facet fetch failed');
          return res.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          swap(doc, '[data-product-grid]');
          swap(doc, '[data-collection-count]');
          swapOrClear(doc, '[data-active-filters]');
          swapFacets(doc);
          if (push && history.pushState) history.pushState({}, '', url);
          paintWishButtons();
        })
        .catch(function () { window.location.href = url; })
        .finally(function () {
          busy = false;
          root.classList.remove('is-loading');
        });
    }

    function formUrl(form) {
      var params = [];
      new FormData(form).forEach(function (value, key) {
        if (String(value).length) params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      var base = form.getAttribute('action') || window.location.pathname;
      return params.length ? base + '?' + params.join('&') : base;
    }

    document.addEventListener('change', function (event) {
      var facetForm = event.target.closest('[data-facet-form]');
      if (facetForm && !event.target.closest('.facet__price')) {
        apply(formUrl(facetForm), true);
        return;
      }
      if (event.target.closest('[data-sort-select]')) {
        var sortForm = event.target.closest('[data-sort-form]');
        if (sortForm) apply(formUrl(sortForm), true);
      }
    });

    var priceTimer;
    document.addEventListener('input', function (event) {
      if (!event.target.closest('.facet__price')) return;
      var form = event.target.closest('[data-facet-form]');
      if (!form) return;
      window.clearTimeout(priceTimer);
      priceTimer = window.setTimeout(function () { apply(formUrl(form), true); }, 600);
    });

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-active-filters] a, .facets__clear, .pagination a');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      event.preventDefault();
      apply(href, true);
      if (link.closest('.pagination')) {
        var grid = document.querySelector('[data-product-grid]');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    window.addEventListener('popstate', function () {
      apply(window.location.pathname + window.location.search, false);
    });
  })();
})();
